import { ButtonIcon, ButtonImage, ButtonLink, ButtonRoot } from './parts';

const Button = Object.assign(ButtonRoot, {
  Icon: ButtonIcon,
  Image: ButtonImage,
  Link: ButtonLink,
});

export default Button;
export * from './parts';
